var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('iframe',{staticClass:"prism-player",attrs:{"src":_vm.pdfUrl,"width":"100%","height":_vm.heights}})])
}
var staticRenderFns = []

export { render, staticRenderFns }